"use client"
import { memo } from "react";
import style from './DegreeProgramWithFilter2.module.scss';
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue } from '@/context/utils';
import ProgramListDetails from './ProgramListDetails';
import { EXCLUDE_PROGRAMS_LANDING_PAGE_URL_KEY } from "./utils";

const DegreeProgramWithFilter2 = ({
    Programs,
    certificationProgram = [],
    country,
    schoolOfAIDetails = [],
    isAffiliatePage = false,
    isProgramListPage = false,
    landingPageValue = "",
    isLandingPage = false,
}) => {
    const hostname = typeof window !== "undefined" ? window.location.host : "";
    const modifyPrograms = Programs?.map((item) => {
        if (item?.domain === "Arts_&_Humanities" || item?.SponsoredKey === 'HCLTECH' || item?.SponsoredKey === "TCS"
            || item?.SponsoredKey === "KPMG" || item?.SponsoredKey === "PAYTM"
        ) {
            item.__typename = "SpecializationEntity"
        }
        return item;
    })?.filter((item) => item?.programName !== "Master of Arts - Psychology");
  

    const fireGTEvents = () => {
        // Keep sync — this is an <a href> navigation; deferred track can drop on unload.
        pushToDataLayer({
            event: "view_all_cta_click",
            cta_text: "All Programs",
            section_name: "program section",
            page_type: getGlobalStateValue("pageType"),
            page_url: window.location.href,
        });
        window?.webengage?.track("Explore All Programs Clicked", {
            "Page Type": getGlobalStateValue("pageType"),
                "Section Name": "Hero Banner",
            });
    };

    const landingPageProgramType =
        landingPageValue === "UG"
            ? "UG_Program"
            : landingPageValue === "PG"
                ? "PG_Program"
                : "";

    const landingPageFilteredPrograms = landingPageProgramType
        ? modifyPrograms
            ?.filter((item) => item?.programType === landingPageProgramType)
            ?.filter(
                (item) =>
                    !EXCLUDE_PROGRAMS_LANDING_PAGE_URL_KEY.includes(
                        item?.attributes?.BasicDetails?.url_key,
                    ),
            )
        : modifyPrograms;

    if (hostname !== "amityonline.com") {
        schoolOfAIDetails = schoolOfAIDetails?.map((item) => {
            const urlKey = item?.attributes?.BasicDetails?.url_key;
            item.attributes.BasicDetails.url_key = urlKey?.replace(
                "https://schoolofai.amityonline.com",
                "http://uat-schoolofai.amityonline.com",
            );
            return item;
        });
    }

    return (
        <section className={style.root}>
            <header className={style.heading} id="degree-program-heading">
                <h2 className={style.heading_text}>Discover our In-Demand online programs</h2>
                {
                    !isProgramListPage && !isAffiliatePage && (
                        <a onClick={fireGTEvents} href="/programs" className={style.explore_btn}>Explore All Programs</a>
                    )
                }
            </header>
            <ProgramListDetails
                DegreePrograms={landingPageFilteredPrograms}
                country={country}
                certificationProgram={certificationProgram}
                schoolOfAIDetailsProgram={schoolOfAIDetails}
                isAffiliatePage={isAffiliatePage}
                landingPageValue={landingPageValue}
                isLandingPage={isLandingPage}
                isProgramListPage={isProgramListPage}
            />
        </section>
    )
}

export default memo(DegreeProgramWithFilter2);
